var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.574 223.359C165.388 184.763 186.788 170.975 195.386 168.905C228.305 161.423 242.854 196.055 246.29 215.442C246.436 216.267 246.497 217.093 246.497 217.93V370.349C246.497 372.019 246.259 373.681 245.639 375.232C241.78 384.878 231.399 400.572 213.186 406.101C208.397 407.554 204.016 410.333 201.016 414.339C190.778 428.014 171.08 445.031 148.574 436.877C123.099 429.234 85.0445 380.417 136.633 246.287",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.533 251.064C182.011 264.12 190.323 289.85 219.747 288.322",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.07 284.501C170.38 291.853 175.783 306.342 194.908 305.481",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380.722 223.359C363.908 184.763 342.508 170.975 333.91 168.905C300.991 161.423 286.443 196.055 283.006 215.442C282.86 216.267 282.799 217.093 282.799 217.93V370.349C282.799 372.019 283.037 373.681 283.657 375.232C287.516 384.878 297.897 400.572 316.11 406.101C320.899 407.554 325.281 410.333 328.28 414.339C338.518 428.014 358.216 445.031 380.722 436.877C406.197 429.234 444.252 380.417 392.663 246.287",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.763 251.064C347.285 264.12 338.974 289.85 309.549 288.322",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.227 284.501C358.916 291.853 353.514 306.342 334.388 305.481",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.407 192.311V92H286.143V192.311C285.761 215.239 312.415 235.938 325.79 243.421L303.339 268.738C266.654 220.589 239.013 248.675 229.778 268.738L211.149 243.421C242.484 219.347 249.044 199.316 248.407 192.311Z",
    fill: "#F9F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.407 92V192.311C249.044 199.316 242.484 219.347 211.149 243.421",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.751 92V192.311C284.114 199.316 290.674 219.347 322.01 243.421",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.122 265.784C243.631 245.881 269.52 220.692 300.473 265.784",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.875 141.372L394.056 74.9998L380.572 128.351L397.056 133.5L335.693 203.547L352.248 146.121L335.875 141.372Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M388.445 188.609L459.397 151.363L430.563 192.165L442.848 201.906L368 241.227L400.767 197.976L388.445 188.609Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/내과_폐수종.24f7f0a14a983a68ab66600355af4061.svg";
export { ForwardRef as ReactComponent };